// extracted by mini-css-extract-plugin
export default {"item":"Role_item__2FTTi","switch":"Role_switch__NEwh0","actions":"Role_actions__EpVm6"};